<script>
    import { createEventDispatcher } from "svelte";
    import { fly } from "svelte/transition";
    import { portal } from "svelte-portal";
    import KeyButton from "./KeyButton.svelte";
    export let show = false;
    const dispatch = createEventDispatcher();
    const clsPrefix = "propad";
    let items = [
        "京",
        "津",
        "沪",
        "渝",
        "冀",
        "豫",
        "云",
        "辽",
        "黑",
        "湘",
        "皖",
        "鲁",
        "新",
        "苏",
        "浙",
        "赣",
        "鄂",
        "桂",
        "甘",
        "晋",
        "蒙",
        "陕",
        "吉",
        "闽",
        "贵",
        "粤",
        "青",
        "藏",
        "川",
        "宁",
        "琼",
        "使",
        "领",
    ];
    export let value = "";
    const select = (num) => () => {
        value = num;
        dispatch("submit");
    };
</script>

{#if show}
    <div class={clsPrefix} transition:fly={{ y: 200 }} use:portal={"body"}>
        {#each items as item}
            <KeyButton
                type="button"
                class={`${clsPrefix}-btn`}
                on:click={select(item)}
                on:click>{item}</KeyButton
            >
        {/each}
    </div>
{/if}

<style lang="less">
    @import "./provincepad.less";
</style>
